<template>
  <div id="app" v-bind:class="{'is-mida': $isMida}">
    <keep-alive>
      <component :is="layout">
        <router-view :key="$route.path" />
      </component>
    </keep-alive>
  </div>
</template>

<script>
const defaultLayout = 'unauth'

/*
:root {
  --primary: rgba(51, 65, 85, 1);
  --sidebar-width: 260px;
  --dd-x: 0;
  --dd-y: 0;
  --body-background: #090c10;
  --background: #1f2226;
  --background-muted: 64, 64, 64;
  --color: #fff;
  --table-hover: #0d111740;
  --color-muted: #dbeaff;
  --color-muted-hover: #f6faff;
  --side-color: #c7d6e6;
  --background-header: #090c10;
  --invert-color: 1;
  --background-table-header: #f7fafc;
}
*/

export default {
  name: 'App',
  beforeCreate() {
  },
  created() {
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    },
  },
  methods: {
  },
  data: function () {
    return {
      auth: false,
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue